import React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Join from './components/Join/Join';
import Chat from './components/Chat/Chat';
const App = () => {
    return (
        <div>
            <Router>
                <Switch>
                    <Route exact path="/">
                        <Join></Join>
                    </Route>
                    <Route path="/chat">
                        <Chat></Chat>
                    </Route>
                </Switch>
            </Router>
        </div>
    );
};

export default App;